// REACT
import React, { useContext, RefObject, useRef, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

// ESTILOS
import Styles from './Policies.module.css'

// CONTEXTO
import MainContext from 'Context/MainContext'
import CloseButton from 'Components/CloseButton/CloseButton'

const Policies: React.FC = () => {
	// CONTEXTO
	const { policies } = useContext(MainContext).lang

	// REFERENCIAS
	const policyRef: RefObject<HTMLDivElement> = useRef(null)

	// ROUTER
	const history = useHistory()

	const goBack = () => {
		// OCULTAR
		if (policyRef.current) policyRef.current.style.opacity = '0'

		// REGRESAR
		setTimeout(() => history.goBack(), 100)
	}

	// MOSTRAR
	useEffect(() => {
		if (policyRef.current) policyRef.current.style.opacity = '1'
	}, [])

	return (
		<section className={`${Styles.container} page`}>
			<div className={Styles.contRow} ref={policyRef}>
				<div className={Styles.contInfo}>
					<h1>{policies.title}</h1>
					<p>
						{policies.intro}
						<br />
						<br />
						{policies.intro_2}
						<br />
						<br />
						<h3 className={Styles.sub}>{policies.subtitle}</h3>
						{policies.ad}
						<br />
						<br />
						{policies.ad_1}
						<br />
						<br />
						{policies.ad_2}
						<br />
						<br />
						{policies.ad_3}
						<br />
						<br />
						{policies.ad_4}
						<br />
						{policies.ad_5}
						<br />
						{policies.ad_2a}
						<br />
						{policies.ad_2b} <br />
						<br />
						{policies.important}
						<br />
						{policies.text}
						<br />
						{policies.text_1}
						<br />
						{policies.text_2} <br />
						<br />
						{policies.text_3}
						<br />
						{policies.text_4} <br />
						{policies.text_5}
						<br />
						{policies.text_6}
						<br />
						<br />
						{policies.text_7}
					</p>
				</div>
				<div className={Styles.contButton}>
					<CloseButton action={goBack} className={Styles.close} />
					<p>{policies.bottom}</p>
				</div>
			</div>
		</section>
	)
}

export default Policies
